import { useEffect, useRef, useState } from 'react'
import { Check } from '@phosphor-icons/react/dist/ssr/Check'
import { CopySimple } from '@phosphor-icons/react/dist/ssr/CopySimple'
import { SeoHead } from '@/components/seo/SeoHead'
import { copyToClipboard } from '@/lib/copyToClipboard'

const pathname = '/firm'

const companyRows = [
  ['Name', 'Disainilahendused OÜ'],
  ['Registry code', '16195052'],
  ['KMKR / VAT', 'EE102560341'],
  ['Address', 'Välja tn 8-57, Kristiine linnaosa, 10616 Tallinn, Harju maakond, Estonia'],
  ['Email', 'knjazevgd@gmail.com'],
  ['Phone', '+372 501 4501'],
  ['Registration date', '30.03.2021'],
] as const

export const CompanyInfoPage = () => {
  const [copiedKey, setCopiedKey] = useState<string | null>(null)
  const resetTimerRef = useRef<number | null>(null)

  useEffect(
    () => () => {
      if (resetTimerRef.current !== null) {
        window.clearTimeout(resetTimerRef.current)
      }
    },
    [],
  )

  const handleCopy = async (label: string, value: string) => {
    const ok = await copyToClipboard(value)
    if (!ok) {
      return
    }

    setCopiedKey(label)
    if (resetTimerRef.current !== null) {
      window.clearTimeout(resetTimerRef.current)
    }
    resetTimerRef.current = window.setTimeout(() => {
      setCopiedKey(null)
      resetTimerRef.current = null
    }, 1400)
  }

  return (
    <>
      <SeoHead pathname={pathname} kind="private-company-info" />
      <div className="site-page mx-auto w-full max-w-[448px] px-4 md:pt-[176px]">
        <header className="mb-8 space-y-2">
          <p className="text-[11px] font-semibold uppercase leading-4 tracking-[0.14em] text-[var(--foreground-subtle)]">
            Private
          </p>
          <h1 className="font-display text-[28px] font-normal leading-[1.08] text-[var(--foreground)]">
            Company details
          </h1>
        </header>

        <section
          aria-label="Company details"
          className="text-[16px] leading-7 tracking-[-0.01em]"
        >
          <ul className="space-y-3">
            {companyRows.map(([label, value]) => {
              const copied = copiedKey === label
              const Icon = copied ? Check : CopySimple

              return (
                <li key={label} className="text-pretty text-[var(--foreground-muted)]">
                  <span>{label} </span>
                  <button
                    type="button"
                    onClick={() => void handleCopy(label, value)}
                    className="group inline text-left font-semibold text-[var(--foreground)] decoration-[var(--border-strong)] decoration-2 underline-offset-4 [transition-property:color,text-decoration-color] duration-150 [transition-timing-function:cubic-bezier(0.2,0,0,1)] hover:decoration-[var(--foreground)] focus-visible:rounded-[3px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-2"
                    aria-label={`Copy ${label}`}
                    title={copied ? 'Copied' : 'Copy'}
                  >
                    <span className="underline decoration-inherit">{value}</span>
                    <Icon
                      size={17}
                      weight={copied ? 'bold' : 'regular'}
                      className="ml-1 inline-block align-[-2px] text-[var(--foreground)]"
                      aria-hidden="true"
                    />
                  </button>
                </li>
              )
            })}
          </ul>
        </section>
      </div>
    </>
  )
}
